import * as React from "react";

import { WhyTdcNextOnVeraBody } from "@/components/engagement/why-tdc-nextonvera-body";
import { WhyTdcNextOnVeraHero } from "@/components/engagement/why-tdc-nextonvera-hero";
import { whyTdcNextOnVeraPage } from "@/content/why-tdc-nextonvera";

/**
 * `/why-tdc-nextonvera` — why the initiative sits inside Tour De Cure,
 * and why NextOnVera is the flagship platform the Fund backs.
 */
export function WhyTdcNextOnVeraPage() {
  React.useEffect(() => {
    const previous = document.title;
    document.title = whyTdcNextOnVeraPage.documentTitle;
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <article className="flex flex-col">
      <WhyTdcNextOnVeraHero />
      <WhyTdcNextOnVeraBody />
    </article>
  );
}
